export default __webpack_public_path__ + "static/media/Snd_TryO.24ea22f3.mp3";